module.exports = __webpack_public_path__ + "static/media/1124_foot_1K.cf19c084.glb";